import React, { useEffect, useState } from "react";
import Header from "../../shef_dashboard/components/Header";
import MenuStepFormModal from "../components/myMenu/MenuStepFormModal";
import NewScreen01 from "../components/myMenu/NewScreen01";
import NewScreen02 from "../components/myMenu/NewScreen02";
import Footer from "../../frontend/components/Footer";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import {
  handleCreateMenu,
  handleGetAllDishes,
  handleGetFoodType,
  handleUpdateMenu,
  handleToggleDishStatus,
  handleToggleAllDishesStatus,
} from "../../services/shef";
import isValidURL from "../../ValidateUrl";
import { shefDetailPath } from "../../shefPath";
import { useLocation } from "react-router-dom";
import AddAnotherDishModal from "../components/myMenu/AddAnotherDishModal"

export const MyMenu = () => {
  const location = useLocation();
  const dish = location.state;
  const [isStepFormModalOpen, setStepFormModalOpen] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [isUpdateDish, setIsUpdateDish] = useState(false);
  const [isPending, setIsPending] = useState(false);
  const [showAddAnotherPrompt, setShowAddAnotherPrompt] = useState(false);
  
  // Share functionality states
  const [showShareMenu, setShowShareMenu] = useState(false);
  const [shareConfirmation, setShareConfirmation] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const [buttonScale, setButtonScale] = useState(1);

  const chefMenuInitialState = {
    name: "",
    food_type_id: "",
    spice_level_id: 2,
    tags: "", 
    portion_size: "",
    portion_type_id: "",
    base_type_id: 1,
    chef_earning_fee: "",
    platform_price: 0,
    delivery_price: 0,
    description: "", 
    item_limit: 10000, 
    is_monday: 0,
    is_tuesday: 0,
    is_wednesday: 0,
    is_thursday: 0,
    is_friday: 0,
    is_saturday: 0,
    is_sunday: 0,
    availability_time_slots: [],
    limit_item_availibility: "", 
    limit_start: "", 
    limit_end: "", 
    instruction_template_id: "", 
    reheating_instruction: "No ingredients required", 
    expiry_days: 1,
    cities: [1],
    packaging: 1, 
    ingredients: [], 
    logo: "", 
  };

  const [chefMenu, setChefMenu] = useState(chefMenuInitialState);
  const updateFields = (fields) => {
    setChefMenu((prev) => {
      return { ...prev, ...fields };
    });
  };

  // Only 2 steps now
  const steps = [
    {
      title: "Dish Details",
      content: <NewScreen01 {...chefMenu} updateFields={updateFields} isEdit={isUpdateDish} />,
    },
    {
      title: "Delivery & Logistics",
      content: <NewScreen02 {...chefMenu} updateFields={updateFields} />,
    },
  ];

const openStepFormModal = () => {
  setStepFormModalOpen(true);

  setTimeout(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, 0);
};

  const closeStepFormModal = () => {
    setStepFormModalOpen(false);
    setCurrentStep(0);
    setChefMenu(chefMenuInitialState);
    setIsUpdateDish(false);
  };

  const resetForNewDish = () => {
    setChefMenu(chefMenuInitialState);
    setCurrentStep(0);
    setIsUpdateDish(false);
    setStepFormModalOpen(true);
  };

  const nextStep = () => {
    if (currentStep === 0) {
      // First screen validation
      const requiredFields = {
        name: chefMenu.name,
        food_type_id: chefMenu.food_type_id,
        spice_level_id: chefMenu.spice_level_id,
        base_type_id: chefMenu.base_type_id,
        portion_size: chefMenu.portion_size,
        portion_type_id: chefMenu.portion_type_id,
        chef_earning_fee: chefMenu.chef_earning_fee,
        description: chefMenu.description, 
        logo: chefMenu.logo, 
      };

      const missingFields = Object.entries(requiredFields)
      .filter(([key, value]) => {
        if (key === "spice_level_id") return value == null;
        else if (key === "heating_instructions") {
          return !value || value.trim().length === 0;
        }
        // Special handling for chef_earning_fee to check if it's a valid number
        else if (key === "chef_earning_fee") {
          return value === "" || value === null || value === undefined || parseFloat(value) < 1;
        }

        return !value;
        
      })
      .map(([key]) => key);


      if (missingFields.length > 0) {
        let toastMessage = "";
        if (missingFields[0] === "name") {
          toastMessage = "Name is required";
        } else if (missingFields[0] === "spice_level_id") {
          toastMessage = "Spice Option is required";
        } else if (missingFields[0] === "food_type_id") {
          toastMessage = "Food Type is required";
        } else if (missingFields[0] === "description") {
          toastMessage = "Description is required";
        } else if (missingFields[0] === "reheating_instruction") {
          toastMessage = "Ingredients (Heating Instructions) are required";
        } else if (missingFields[0] === "logo") {
          toastMessage = "Dish photo is required";
        } else if (missingFields[0] === "chef_earning_fee") {
          toastMessage = "Base Price is required and must be at least 1 PKR";
        } else if (
          missingFields[0] === "base_type_id" ||
          missingFields[0] === "portion_size" ||
          missingFields[0] === "portion_type_id"
        ) {
          toastMessage = "Please fill in all fields from Base Serving and Submit";
        }
        toast.dismiss();
        toast.error(toastMessage);
        return;
      }
    } else if (currentStep === 1) {
      // Second screen validation
      const hasActiveDay = [
        chefMenu.is_monday,
        chefMenu.is_tuesday,
        chefMenu.is_wednesday,
        chefMenu.is_thursday,
        chefMenu.is_friday,
        chefMenu.is_saturday,
        chefMenu.is_sunday,
      ].some(day => day === 1);

      if (!hasActiveDay) {
        toast.error("Please select at least one day for availability.");
        return;
      }

      if (chefMenu.availability_time_slots?.length < 1) {
        toast.error("Please Select Availability Slot");
        return;
      }

      if (!chefMenu.cities || chefMenu.cities.length < 1) {
        toast.error("Please Select at least one city");
        return;
      }
     
      onSubmit();
      return;
    }

    setCurrentStep(currentStep + 1);
  };

  const prevStep = () => {
    setCurrentStep(currentStep - 1);
  };

  const { authToken, userInfo } = useSelector((state) => state.user);
  const [dishes, setDishes] = useState([]);
  const [allDishes, setAllDishes] = useState([]);
  const [foodType, setFoodType] = useState([]);
  const [filterDishBy, setFilterDishBy] = useState({
    food_type: "",
    weekdays: "",
    name: "",
  });

  useEffect(() => {
    (async () => {
      try {
        const res = await handleGetAllDishes(authToken);
        setDishes(res);
        setAllDishes(res); // Moved inside try block

        // --- FIX START ---
        if (dish) {
          // Check if the state is specifically asking to Add a New Dish (from Header)
          if (dish.openAddDishModal) {
            resetForNewDish();
            // Optional: Clear history state so refresh doesn't re-trigger
            window.history.replaceState({}, document.title);
          } else {
            // Otherwise, assume it's a dish object for editing
            openStepFormModalToUpdate(dish);
          }
        }
        // --- FIX END ---

      } catch (error) {
        console.error("Error while fetching dishes \n", error);
      }
      try {
        const foodTypeResponse = await handleGetFoodType(authToken);
        setFoodType(foodTypeResponse);
      } catch (error) {
        console.error("Error while fetching Food Type \n", error);
      }
    })();
  }, [authToken]);

  const onFilterChange = (filterBy, e) => {
    const value = e.target.value;
    setFilterDishBy((prevState) => ({
      ...prevState,
      [filterBy]: value,
    }));
  };

  useEffect(() => {
    let filteredDishes = allDishes;

    if (filterDishBy.weekdays) {
      if (filterDishBy.weekdays === "is_all_day") {
        filteredDishes = filteredDishes.filter((dish) => 
          dish.is_monday === 1 &&
          dish.is_tuesday === 1 &&
          dish.is_wednesday === 1 &&
          dish.is_thursday === 1 &&
          dish.is_friday === 1 &&
          dish.is_saturday === 1 &&
          dish.is_sunday === 1
        );
      } else {
        const key = filterDishBy.weekdays;
        filteredDishes = filteredDishes.filter((dish) => dish[key] === 1);
      }
    }

    if (filterDishBy.food_type) {
      const value = parseInt(filterDishBy.food_type, 10);
      filteredDishes = filteredDishes.filter(
        (dish) => dish.food_type_id === value
      );
    }

    if (filterDishBy.name) {
      filteredDishes = filteredDishes.filter((dish) =>
        dish.name.toLowerCase().includes(filterDishBy.name.toLowerCase())
      );
    }

    setDishes(filteredDishes);
  }, [filterDishBy, allDishes]);

  const openStepFormModalToUpdate = (dish) => {
    setIsUpdateDish(true);
    setStepFormModalOpen(true);
    
    const transformedDish = {
      ...dish,
      limit_item_availibility: dish.limit_item_availibility || "",
      limit_start: dish.limit_start || "",
      limit_end: dish.limit_end || ""
    };

    setChefMenu(transformedDish);
    
    const ingredientsId = dish.ingredients?.map((obj) => obj.ingredient_id) || [];
    const citiesId = dish.cities?.map((city) => city.id) || [];
    updateFields({ ingredients: ingredientsId, cities: citiesId });
  };

  const handleAddAnotherYes = () => {
    setShowAddAnotherPrompt(false);
    resetForNewDish();
  };

  const handleAddAnotherNo = () => {
    setShowAddAnotherPrompt(false);
    closeStepFormModal();
  };

  const onSubmit = async (e) => {
    try {
      setIsPending(true);
      toast.dismiss();
      
      // Hardcode tags to food category
      const selectedFoodType = foodType.find(type => type.id === chefMenu.food_type_id);
      const tags = selectedFoodType ? selectedFoodType.name : "Food";
      
      const payload = {
        ...chefMenu,
        name: chefMenu.name,
        food_type_id: chefMenu.food_type_id,
        spice_level_id: chefMenu.spice_level_id,
        tags: tags,
        portion_size: chefMenu.portion_size,
        portion_type_id: chefMenu.portion_type_id,
        base_type_id: chefMenu.base_type_id,
        chef_earning_fee: chefMenu.chef_earning_fee,
        platform_price: chefMenu.platform_price || 0,
        delivery_price: chefMenu.delivery_price || 0,
        description: chefMenu.description,
        item_limit: 10000,
        is_monday: chefMenu.is_monday || 0,
        is_tuesday: chefMenu.is_tuesday || 0,
        is_wednesday: chefMenu.is_wednesday || 0,
        is_thursday: chefMenu.is_thursday || 0,
        is_friday: chefMenu.is_friday || 0,
        is_saturday: chefMenu.is_saturday || 0,
        is_sunday: chefMenu.is_sunday || 0,
        expiry_days: 1,
        packaging: 1,
        reheating_instruction: chefMenu.reheating_instruction,
        limit_item_availibility: "",
        limit_start: "",
        limit_end: "",
        instruction_template_id: "",
      };

      if (isUpdateDish) {
        const availability_time_slots_id_only = [];
        payload.availability_time_slots?.forEach((item) => {
          if (item.availability_time_slots_id) {
            availability_time_slots_id_only.push(item.availability_time_slots_id);
          }
        });
        
        const updatePayload = {
          ...payload,
          availability_time_slots: availability_time_slots_id_only.length > 0
            ? availability_time_slots_id_only
            : payload.availability_time_slots,
        };

        const updateMenu = await handleUpdateMenu(chefMenu.id, authToken, updatePayload);
        toast.success(updateMenu.message);
      } else {
        const response = await handleCreateMenu(authToken, payload);
        toast.success(response.message);
        setShowAddAnotherPrompt(true);
      }
      
      const updateDishes = await handleGetAllDishes(authToken);
      setDishes(updateDishes);
      setAllDishes(updateDishes);
      closeStepFormModal();
      
    } catch (error) {
      toast.error(error.message || "Something went wrong");
    } finally {
      setIsPending(false);
    }
  };

  // Kitchen is "on" when at least one dish is live
  const anyDishLive = dishes.some((d) => !!d.is_live);

  const refreshDishes = async () => {
    try {
      const fresh = await handleGetAllDishes(authToken);
      setDishes(fresh);
      setAllDishes(fresh);
    } catch (error) {
      console.error("Error while refreshing dishes \n", error);
    }
  };

  // Auto-reload dish state when the kitchen is toggled from the
  // dashboard header, or when the user returns to this tab
  useEffect(() => {
    const onKitchenChanged = () => refreshDishes();
    const onVisible = () => {
      if (document.visibilityState === "visible") refreshDishes();
    };
    window.addEventListener("kitchen:changed", onKitchenChanged);
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      window.removeEventListener("kitchen:changed", onKitchenChanged);
      document.removeEventListener("visibilitychange", onVisible);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authToken]);

  const handleKitchenToggle = async () => {
    if (anyDishLive && !window.confirm(
      "Turn your kitchen OFF? All dishes will be hidden except those with accepted orders pending delivery."
    )) {
      return;
    }
    try {
      toast.dismiss();
      setIsPending(true);
      const response = await handleToggleAllDishesStatus(authToken, !anyDishLive);
      toast.success(response.message);
      if (response.skipped?.length) {
        toast.warning(
          `Kept live: ${response.skipped.map((d) => d.name).join(", ")}`,
          { autoClose: 8000 }
        );
      }
      // Refreshes this page's dishes and the header's kitchen state
      window.dispatchEvent(new Event("kitchen:changed"));
      await refreshDishes();
    } catch (error) {
      toast.error(error.message || "Failed to update kitchen status");
    } finally {
      setIsPending(false);
    }
  };

  const handleToggleStatus = async (dishId) => {
    try {
      toast.dismiss();
      const response = await handleToggleDishStatus(authToken, dishId);
      toast.success(response.message);
      
      // Update the dishes list to reflect the new status
      const updatedDishes = dishes.map(dish => 
        dish.id === dishId ? { ...dish, is_live: response.is_live } : dish
      );
      setDishes(updatedDishes);
      setAllDishes(updatedDishes);
    } catch (error) {
      toast.error(error.message || "Failed to toggle dish status");
    }
  };

  // Share functionality
  const chefId = userInfo?.id;
  const chefName = `${userInfo?.first_name || "Chef"} ${userInfo?.last_name || ""}`;
  const shareUrl = chefId 
    ? `https://shefscloud.com${shefDetailPath(chefId, userInfo?.first_name, userInfo?.last_name)}`
    : 'https://shefscloud.com';
  const shareMessage = `Check out ${chefName}'s amazing menu on Shef! 🍽️\n\n${shareUrl}`;
  const shareSubject = `${chefName}'s Chef Profile`;

  const handleSharePress = () => {
    // Button animation
    setButtonScale(0.95);
    setTimeout(() => setButtonScale(1), 100);
    setShowShareMenu(true);
  };

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setIsCopied(true);
      setShareConfirmation(true);
      setTimeout(() => {
        setShareConfirmation(false);
        setIsCopied(false);
      }, 2000);
      setShowShareMenu(false);
      // REMOVED: toast.success("Link copied to clipboard!"); // Fixed duplicate toast
    } catch (error) {
      toast.error("Failed to copy link");
    }
  };

  /* WhatsApp share disabled for now — uncomment to re-enable
  const shareViaWhatsApp = () => {
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(shareMessage)}`;
    window.open(whatsappUrl, '_blank');
    setShowShareMenu(false);
  };
  */

  const shareViaEmail = () => {
    const emailUrl = `mailto:?subject=${encodeURIComponent(shareSubject)}&body=${encodeURIComponent(shareMessage)}`;
    window.open(emailUrl, '_self');
    setShowShareMenu(false);
  };

  const shareViaInstagram = () => {
    copyToClipboard();
    // REMOVED: toast.info("Link copied! You can now paste it in your Instagram post or story."); // Fixed duplicate toast
  };

  const shareViaFacebook = () => {
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;
    window.open(facebookUrl, '_blank', 'width=600,height=400');
    setShowShareMenu(false);
  };

  const shareViaTwitter = () => {
    const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareMessage)}`;
    window.open(twitterUrl, '_blank', 'width=600,height=400');
    setShowShareMenu(false);
  };

  const openShareSheet = () => {
    if (navigator.share) {
      navigator.share({
        title: shareSubject,
        text: shareMessage,
        url: shareUrl,
      })
      .then(() => console.log('Successfully shared'))
      .catch((error) => console.log('Error sharing:', error));
      setShowShareMenu(false);
    } else {
      // Fallback to copy link
      copyToClipboard();
    }
  };

  // Share platforms data
  const sharePlatforms = [
    /* WhatsApp share disabled for now — uncomment to re-enable
    {
      id: 'whatsapp',
      name: 'WhatsApp',
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm.14 18.115c-3.416 0-6.194-2.776-6.194-6.194 0-3.416 2.778-6.194 6.194-6.194 3.416 0 6.194 2.778 6.194 6.194 0 3.418-2.778 6.194-6.194 6.194zm3.23-4.683c-.182-.092-.944-.466-1.09-.52-.147-.054-.254-.081-.362.081-.107.163-.42.52-.515.628-.094.107-.189.121-.35.04-.163-.081-.686-.253-1.307-.807-.483-.43-.808-.96-.902-1.122-.095-.163-.01-.251.07-.332.072-.072.163-.189.245-.283.081-.094.109-.163.163-.272.054-.108.027-.203-.014-.284-.041-.081-.362-.872-.496-1.196-.131-.318-.263-.275-.362-.28-.094-.004-.203-.005-.312-.005-.108 0-.284.04-.434.202-.148.162-.567.554-.567 1.35s.581 1.566.662 1.675c.081.108 1.147 1.753 2.779 2.457.388.164.691.261.927.334.388.108.741.093 1.02.057.313-.042.944-.386 1.077-.764.134-.378.134-.702.094-.764-.042-.062-.162-.093-.344-.185z"/>
        </svg>
      ),
      color: '#25D366',
      bgColor: 'bg-green-50',
      action: shareViaWhatsApp,
    },
    */
    {
      id: 'facebook',
      name: 'Facebook',
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
        </svg>
      ),
      color: '#1877F2',
      bgColor: 'bg-blue-50',
      action: shareViaFacebook,
    },
    {
      id: 'twitter',
      name: 'Twitter',
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.213c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
        </svg>
      ),
      color: '#1DA1F2',
      bgColor: 'bg-blue-50',
      action: shareViaTwitter,
    },
    {
      id: 'email',
      name: 'Email',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
        </svg>
      ),
      color: '#EA4335',
      bgColor: 'bg-red-50',
      action: shareViaEmail,
    },
    {
      id: 'instagram',
      name: 'Instagram',
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
        </svg>
      ),
      color: '#E1306C',
      bgColor: 'bg-pink-50',
      action: shareViaInstagram,
    },
    {
      id: 'copy',
      name: 'Copy Link',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
        </svg>
      ),
      color: '#8B5CF6',
      bgColor: 'bg-purple-50',
      action: copyToClipboard,
    },
  ];

  return (
    <div className="bg-gray-50 min-h-screen">
      <Header />
      <div className="container mx-auto px-4 py-8 max-w-7xl">
        {/* Filter Section */}
        <div className="bg-white rounded-xl shadow-md p-8 mb-8">
          <h2 className="text-2xl font-semibold text-gray-800 mb-6">Filter</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                You can filter by weekday.
              </label>
              <select
                value={filterDishBy.weekdays}
                onChange={(e) => onFilterChange("weekdays", e)}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-600 focus:border-red-600 transition-all"
              >
                <option value="">Select Any Day</option>
                <option value="is_all_day">All Day</option>
                <option value="is_monday">Monday</option>
                <option value="is_tuesday">Tuesday</option>
                <option value="is_wednesday">Wednesday</option>
                <option value="is_thursday">Thursday</option>
                <option value="is_friday">Friday</option>
                <option value="is_saturday">Saturday</option>
                <option value="is_sunday">Sunday</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                You can filter by food type.
              </label>
              <select
                value={filterDishBy.food_type}
                onChange={(e) => onFilterChange("food_type", e)}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-600 focus:border-red-600 transition-all"
              >
                <option value="">Select Food Type</option>
                <option value="">All</option>
                {foodType?.map((type) => (
                  <option key={type.id} value={type.id}>
                    {type.name}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                You can filter by Name.
              </label>
              <input
                type="search"
                onChange={(e) => onFilterChange("name", e)}
                value={filterDishBy.name}
                placeholder="Type Dish Name"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-600 focus:border-red-600 transition-all"
              />
            </div>
          </div>
        </div>

        {/* Dish Catalogue Header */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8 gap-4">
          <h1 className="text-3xl font-bold text-gray-900">
            Dish Catalogue ({dishes.length})
          </h1>
          <div className="flex flex-col md:flex-row gap-4 w-full md:w-auto">
            {/* Share My Menu Button */}
            <button
              onClick={handleSharePress}
              className="flex items-center justify-center gap-2 bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white font-semibold py-3 px-6 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-[0.98] active:scale-[0.95]"
              style={{ transform: `scale(${buttonScale})` }}
            >
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                className="w-5 h-5" 
                fill="none" 
                viewBox="0 0 24 24" 
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
              </svg>
              Share My Menu
            </button>

            {/* Kitchen On/Off Toggle */}
            <button
              onClick={handleKitchenToggle}
              disabled={isPending || dishes.length === 0}
              className={`bg-white font-medium py-3 px-6 rounded-lg transition-colors duration-300 shadow-sm disabled:opacity-50 disabled:cursor-not-allowed border text-black ${
                anyDishLive
                  ? "border-red-600 hover:bg-red-50"
                  : "border-green-600 hover:bg-green-50"
              }`}
            >
              Kitchen{" "}
              <span className={anyDishLive ? "text-red-600" : "text-green-600"}>
                {anyDishLive ? "Off" : "On"}
              </span>
            </button>

            {/* Add New Dish Button */}
            <button
              onClick={openStepFormModal}
              className="bg-red-600 hover:bg-red-700 text-white font-medium py-3 px-6 rounded-lg transition-colors duration-300 shadow-md hover:shadow-lg"
            >
              Add New Dish
            </button>
          </div>
        </div>

        {/* Share Menu Modal - CHANGED: Fixed black overlay issue */}
        {showShareMenu && (
          <>
            <div 
              className="fixed inset-0 z-50 flex items-center justify-center px-4 py-6 md:p-0 bg-black/30 backdrop-blur-sm"
              onClick={() => setShowShareMenu(false)}
            >
              <div 
                className="bg-white rounded-2xl md:rounded-3xl w-full max-w-md shadow-2xl transform transition-all duration-300 max-h-[90vh] overflow-y-auto"
                onClick={(e) => e.stopPropagation()}
              >
                {/* Header */}
                <div className="p-6 border-b border-gray-100 relative">
                  <div className="flex items-center justify-center mb-4">
                    <div className="w-14 h-14 bg-red-50 rounded-full flex items-center justify-center">
                      <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        className="w-7 h-7 text-red-600" 
                        fill="none" 
                        viewBox="0 0 24 24" 
                        stroke="currentColor"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
                      </svg>
                    </div>
                  </div>
                  <h2 className="text-2xl font-bold text-gray-900 text-center mb-2">
                    Share Your Menu
                  </h2>
                  <p className="text-gray-600 text-center text-sm mb-4">
                    Share your chef profile and menu with customers
                  </p>
                  <button
                    onClick={() => setShowShareMenu(false)}
                    className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 transition-colors"
                  >
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>

                {/* URL Display */}
                <div className="p-6 border-b border-gray-100">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Your Profile Link
                  </label>
                  <div className="flex items-center bg-gray-50 border border-gray-200 rounded-lg p-3">
                    <span className="text-sm text-gray-700 truncate flex-1">
                      {shareUrl}
                    </span>
                    <button
                      onClick={copyToClipboard}
                      className="ml-2 p-2 text-blue-600 hover:text-blue-800 transition-colors"
                      title="Copy link"
                    >
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                      </svg>
                    </button>
                  </div>
                </div>

                {/* Share Platforms */}
                <div className="p-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-4">Share via</h3>
                  <div className="grid grid-cols-3 gap-4">
                    {sharePlatforms.map((platform) => (
                      <button
                        key={platform.id}
                        onClick={platform.action}
                        className={`flex flex-col items-center justify-center p-4 ${platform.bgColor} rounded-xl hover:shadow-lg transition-all duration-300 transform hover:scale-105 active:scale-95`}
                      >
                        <div 
                          className="w-12 h-12 rounded-full flex items-center justify-center mb-2"
                          style={{ backgroundColor: `${platform.color}20` }}
                        >
                          <span style={{ color: platform.color }}>
                            {platform.icon}
                          </span>
                        </div>
                        <span className="text-sm font-medium text-gray-700">
                          {platform.name}
                        </span>
                      </button>
                    ))}
                  </div>
                  
                  {/* Native Share Button */}
                  {navigator.share && (
                    <button
                      onClick={openShareSheet}
                      className="w-full mt-6 flex items-center justify-center gap-2 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium py-3 px-4 rounded-lg transition-colors duration-300"
                    >
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
                      </svg>
                      More Options
                    </button>
                  )}
                </div>
              </div>
            </div>
          </>
        )}

        {/* Share Confirmation Toast - UPDATED: Shows only when link is copied */}
        {shareConfirmation && (
          <div className="fixed top-4 right-4 z-50 animate-fade-in">
            <div className="bg-white rounded-xl shadow-lg p-6 border border-green-200 max-w-sm">
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <svg className="w-8 h-8 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <div className="ml-3">
                  <h3 className="text-lg font-semibold text-gray-900">Link Copied!</h3>
                  <p className="text-gray-600 mt-1">
                    Your profile link has been copied to clipboard
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Dish Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {dishes?.map((dish) => (
            <div
              key={dish.id}
              className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300"
            >
              <div className="h-48 relative overflow-hidden">
                <img
                  src={
                    dish.logo && isValidURL(dish.logo)
                      ? dish.logo
                      : "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/330px-No-Image-Placeholder.svg.png?20200912122019"
                  }
                  alt={dish.name}
                  className="w-full h-full object-cover"
                />
                <button
                  onClick={() => openStepFormModalToUpdate(dish)}
                  className="absolute top-2 right-2 p-2 bg-yellow-500 hover:bg-yellow-600 text-white rounded-full shadow transition duration-300"
                  title="Edit"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg" 
                    viewBox="0 0 24 24"
                    width="16"
                    height="16"
                    fill="currentColor"
                  >
                    <path d="M15.7279 9.57627L14.3137 8.16206L5 17.4758V18.89H6.41421L15.7279 9.57627ZM17.1421 8.16206L18.5563 6.74785L17.1421 5.33363L15.7279 6.74785L17.1421 8.16206ZM7.24264 20.89H3V16.6473L16.435 3.21231C16.8256 2.82179 17.4587 2.82179 17.8492 3.21231L20.6777 6.04074C21.0682 6.43126 21.0682 7.06443 20.6777 7.45495L7.24264 20.89Z"></path>
                  </svg>
                </button>
              </div>

              <div className="p-6">
                <div className="flex justify-between items-start mb-3">
                  <h3 className="text-xl font-bold text-gray-900 truncate max-w-[200px]" title={dish.name}>
                   {dish.name}
                  </h3>
                  <button
                    onClick={() => handleToggleStatus(dish.id)}
                    className={`flex items-center gap-2 text-xs font-medium px-3 py-2 rounded-full transition-all duration-300 transform hover:scale-105 active:scale-95 shadow-md hover:shadow-lg cursor-pointer ${
                      dish.is_live 
                        ? 'bg-gradient-to-r from-green-100 to-green-200 text-green-800 hover:from-green-200 hover:to-green-300 border border-green-300' 
                        : 'bg-gradient-to-r from-red-100 to-red-200 text-red-800 hover:from-red-200 hover:to-red-300 border border-red-300'
                    }`}
                    title={dish.is_live ? 'Click to deactivate dish' : 'Click to activate dish'}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg" 
                      viewBox="0 0 24 24"
                      width="14"
                      height="14"
                      fill="currentColor"
                    >
                      {dish.is_live ? (
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                      ) : (
                        <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="2"/>
                      )}
                    </svg>
                    <span className="font-semibold">
                      {dish.is_live ? 'Active' : 'Inactive'}
                    </span>
                  </button>
                </div>
                <p className="text-gray-600 mb-4 line-clamp-2">
                  {dish.description}
                </p>
                
                <div className="text-xl font-bold text-red-600 mb-4">
                  {(
                    dish.chef_earning_fee +
                    dish.platform_price +
                    dish.delivery_price
                  ).toLocaleString("en-PK", {
                    style: "currency",
                    currency: "PKR",
                  })}
                </div>
                <div className="flex justify-between items-center">
                  <div className="flex flex-wrap gap-1">
                    {[
                      "is_monday",
                      "is_tuesday",
                      "is_wednesday",
                      "is_thursday",
                      "is_friday",
                      "is_saturday",
                      "is_sunday",
                    ].map((day, index) => (
                      <span
                        key={index}
                        className={`px-2 py-1 text-xs rounded-full ${
                          dish[day] === 1
                            ? "bg-red-600 text-white"
                            : "bg-gray-200 text-gray-600"
                        }`}
                      >
                        {["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"][index]}
                      </span>
                    ))}
                  </div>
                </div>
                <div className="mt-3 text-xs text-gray-500 italic">
                  Changes Pending Review
                </div>
              </div>
            </div>
          ))}
          {dishes.length < 1 && (
            <div className="col-span-full text-center py-12">
              <p className="text-gray-500 text-lg">No dishes found</p>
            </div>
          )}
        </div>

        {/* Modals */}
        <MenuStepFormModal
          onSubmit={onSubmit}
          isPending={isPending}
          isOpen={isStepFormModalOpen}
          onClose={closeStepFormModal}
          steps={steps}
          currentStep={currentStep}
          onNext={nextStep}
          onBack={prevStep}
        />
        <AddAnotherDishModal
          isOpen={showAddAnotherPrompt}
          onYes={handleAddAnotherYes}
          onNo={handleAddAnotherNo}
        />

      </div>
      <Footer />
      
      {/* Add custom styles for animations */}
      <style jsx>{`
        @keyframes fade-in {
          from { opacity: 0; transform: translateY(-10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-in {
          animation: fade-in 0.3s ease-out;
        }
      `}</style>
    </div>
  );
};
export default MyMenu;